var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvato1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8231 0.913729C12.3199 0.633764 10.8773 0.80688 9.14459 1.34466C6.11217 3.42283 3.55276 6.48461 3.37424 11.4015C3.34178 11.5191 3.0426 11.3854 2.98355 11.3491C2.16463 9.77538 1.84023 8.11833 2.52403 5.72784C2.65133 5.51512 2.23463 5.25339 2.15974 5.32789C2.00977 5.47885 1.38404 6.147 0.96852 6.86966C-1.09129 10.4522 0.25578 15.0424 3.85937 17.0513C7.46217 19.0632 12.0118 17.7654 14.0178 14.1519C16.3389 9.98143 14.1838 1.6756 12.8231 0.913925V0.913729Z",
    fill: "#82B541"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvato1);
export default __webpack_public_path__ + "static/media/envato_1.072d7f7d3aaa4582502e8530446c2cbf.svg";
export { ForwardRef as ReactComponent };